import { useEffect, useState } from "react";
import useDataFetch from "./useDataFetch";
import useSociety from "./useSociety";

export interface ConnectedAccountStatePublicDTO {
    ready: boolean;
}

const useStripeCheckAccountPublic = (societySecured: boolean) => {

    const {society} = useSociety();

    const [isLoadingConnectedAccountStatePublic, setIsLoadingConnectedAccountStatePublic] = useState<boolean>(false);
    const [isAccountReady, setIsAccountReady] = useState<boolean>(false);

    const { fetchDataPromise: retrieveConnectedAccountPublicState } = useDataFetch<ConnectedAccountStatePublicDTO>(
        `/stripe/connected-account/retrieve-connnected-account-by-society-id/${society.id}`,
        false,
        false
    );

    useEffect(() => {
        if (!societySecured) {
            setIsLoadingConnectedAccountStatePublic(true);
            retrieveConnectedAccountPublicState(`/stripe/connected-account/retrieve-connnected-account-by-society-id/${society.id}`)
                .then((response) => {
                    if (response.data) {
                        setIsAccountReady(response.data.ready);
                    }
                })
                .finally(() => {
                    setIsLoadingConnectedAccountStatePublic(false);
                });
        }
    }, [societySecured, society]);

    return {
        isAccountReady,
        isLoadingConnectedAccountStatePublic,
    };
};

export default useStripeCheckAccountPublic;
